/**
 *
 * Returns the object prefix from a node id
 */
export const getObjectNameFromNodeId = (id: string) => {
  return id.split(":")[0];
};

export const getFlatIdFromNodeId = (id: string) => {
  return id.split(":")[1];
};
